import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltAutocompleteChipTooltipNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-chip-tooltip-name-wireframe", __assign({}, transformedProps), children));
};
export default VeltAutocompleteChipTooltipNameWireframe;
